<template>
    <div class="row">
        <div class="col-12">
            <div class="form-group">
                <MaterialInput
                    :readonly="readonlyForm"
                    :disabled="readonlyForm"
                    class="city-form-group city-bg"
                    id="input-interment_number"
                    name="interment_number"
                    v-model.trim="form.interment.number"
                    v-validate="{integer: true, min_value:0}"
                    :data-vv-scope="vScope"
                    :inputClasses="[{'is-invalid': fnHasError('interment_number', vScope) }]"
                    :error="fnFirstError('interment_number', vScope)">
                    {{ $t(`${modelTranslateID}.interment_number`) }}
                </MaterialInput>
            </div>
        </div>
        <div class="col-12">
            <div class="form-group">
                <MaterialDateRangePicker
                    class="city-form-group city-bg"
                    id="input-entity_death_at"
                    name="entity_death_at"
                    v-model.trim="form.interment.interment_at"
                    :dateFormat="labelDateFormat"
                    :databaseDateFormat="dateFormat"
                    v-validate="''"
                    :data-vv-scope="vScope"
                    :inputClasses="[{'is-invalid': fnHasError('interment_at', vScope) }]"
                    :error="fnFirstError('interment_at', vScope)">
                    {{ $t(`${modelTranslateID}.interment_at`) }}
                </MaterialDateRangePicker>
            </div>
        </div>
        <div class="col-12">
            <label>{{ $t(`${entityTranslateID}.form.deceased_entity`) }}</label>
            <div class="row">
                <div class="col-12">
                    <div class="form-group">
                        <MaterialInput
                            :readonly="readonlyForm"
                            :disabled="readonlyForm"
                            class="city-form-group city-bg"
                            id="input-entity_name"
                            v-model.trim="form.interment.entity.name"
                            v-validate="''"
                            :data-vv-scope="vScope"
                            :inputClasses="[{'is-invalid': fnHasError('entity_name', vScope) }]"
                            :error="fnFirstError('entity_name', vScope)">
                            {{ $t(`${modelEntityTranslateID}.name`) }}
                        </MaterialInput>
                    </div>
                </div>
                <div class="col-12">
                    <div class="form-group">
                        <MaterialDateRangePicker
                            class="city-form-group city-bg"
                            id="input-entity_birth_at"
                            name="entity_birth_at"
                            v-model.trim="form.interment.entity.birth_at"
                            :dateFormat="labelDateFormat"
                            :databaseDateFormat="dateFormat"
                            v-validate="''"
                            :data-vv-scope="vScope"
                            :inputClasses="[{'is-invalid': fnHasError('entity_birth_at', vScope) }]"
                            :error="fnFirstError('entity_birth_at', vScope)">
                            {{ $t(`${modelEntityTranslateID}.birth_at`) }}
                        </MaterialDateRangePicker>
                    </div>
                </div>
                <div class="col-12">
                    <div class="form-group">
                        <MaterialDateRangePicker
                            class="city-form-group city-bg"
                            id="input-entity_death_at"
                            name="entity_death_at"
                            v-model.trim="form.interment.entity.death_at"
                            :dateFormat="labelDateFormat"
                            :databaseDateFormat="dateFormat"
                            v-validate="''"
                            :data-vv-scope="vScope"
                            :inputClasses="[{'is-invalid': fnHasError('entity_death_at', vScope) }]"
                            :error="fnFirstError('entity_death_at', vScope)">
                            {{ $t(`${modelEntityTranslateID}.death_at`) }}
                        </MaterialDateRangePicker>
                    </div>
                </div>
                <div class="col-12">
                    <div class="row">
                        <div class="col-auto d-flex align-items-center">
                            <div class="form-group">
                                <span>{{ $t(`${entityTranslateID}.form.age`) }}</span>
                            </div>
                        </div>
                        <div class="col-sm">
                            <div class="form-group">
                                <MaterialInput
                                    :readonly="readonlyForm"
                                    :disabled="readonlyForm"
                                    type="number"
                                    class="city-form-group city-bg"
                                    id="input-fromAge"
                                    name="fromAge"
                                    v-model.trim="form.interment.entity.age.from"
                                    v-validate="{integer: true, min_value:0}"
                                    :data-vv-scope="vScope"
                                    :inputClasses="[{'is-invalid': fnHasError('fromAge', vScope) }]"
                                    :error="fnFirstError('fromAge', vScope)">
                                    {{ $t(`${modelEntityTranslateID}.from_age`) }}
                                </MaterialInput>
                            </div>
                        </div>
                        <div class="col-auto d-flex align-items-center">
                            <div class="form-group">
                                <span>-</span>
                            </div>
                        </div>
                        <div class="col-sm">
                            <div class="form-group">
                                <MaterialInput
                                    :readonly="readonlyForm"
                                    :disabled="readonlyForm"
                                    type="number"
                                    class="city-form-group city-bg"
                                    id="input-toAge"
                                    name="toAge"
                                    v-model.trim="form.interment.entity.age.to"
                                    v-validate="{integer: true, min_value: form.interment.entity.age.from ?? 0 }"
                                    :data-vv-scope="vScope"
                                    :inputClasses="[{'is-invalid': fnHasError('toAge', vScope) }]"
                                    :error="fnFirstError('toAge', vScope)">
                                    {{ $t(`${modelEntityTranslateID}.to_age`) }}
                                </MaterialInput>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import SearchFormMixin from "../mixins/SearchFormMixin";

export default {
    mixins: [
        SearchFormMixin,
    ],
    props: {
    },
    data() {
        return {
        }
    },
    computed: {
        entityTranslateID() {
            return `entities`;
        },
        modelEntityTranslateID() {
            return `${this.entityTranslateID}.model`;
        },
    },
    methods: {

    }
}
</script>

<style lang="scss" scoped>

</style>